/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ApiActionConfig } from "../../commons/types/ApiActionConfig";
export const ApiActionConfigs = core.serialization.list(ApiActionConfig);
